import { gql } from '__generated__v2/gql';

export const F_MapMarkerLabel = gql(`
    fragment F_MapMarkerLabel on MapMarkerLabel {
        id
        isHidden
        isLocked
        floorIds
        type
        selectable
        layerName
        isLayerNameEdited
        createdAt
        updatedAt

        lat
        lng
        text
        imageUrl
        smallImageUrl
        generatedBackgroundColor
        generatedIconName
    }
`);

export const F_MapMarkerIndoorStand = gql(`
    fragment F_MapMarkerIndoorStand on MapMarkerIndoorStand {
        id
        isHidden
        isLocked
        floorIds
        type
        selectable
        layerName
        isLayerNameEdited
        createdAt
        updatedAt

        lng
        lat
        color
        darkColor
        text
        logoUrl
        showStructure
        width
        height
        rotation
        hasInteractivity
    }
`);

export const F_MapMarkerDirection = gql(`
    fragment F_MapMarkerDirection on MapMarkerDirection {
        id
        isHidden
        isLocked
        floorIds
        type
        selectable
        layerName
        isLayerNameEdited
        createdAt
        updatedAt

        coordinates {
            lng
            lat
        }
        path {
            lng
            lat
        }
        transportType
        color
        opacity
        width
    }
`);

export const F_MapMarkerRoute = gql(`
    fragment F_MapMarkerRoute on MapMarkerRoute {
        id
        isHidden
        isLocked
        floorIds
        type
        selectable
        layerName
        isLayerNameEdited
        createdAt
        updatedAt
        isDashed
        dashedGapLength
        dashedLineLength

        coordinates {
            lng
            lat
        }
        opacity
        color
        width
    }
`);

export const F_MapMarkerLine = gql(`
    fragment F_MapMarkerLine on MapMarkerLine {
        id
        isHidden
        isLocked
        floorIds
        type
        selectable
        layerName
        isLayerNameEdited
        createdAt
        updatedAt

        coordinates {
            lng
            lat
        }
        color
        opacity
        width
        isDashed
        dashedLineLength
        dashedGapLength
    }
`);

export const F_MapMarkerPolygon = gql(`
    fragment F_MapMarkerPolygon on MapMarkerPolygon {
        id
        isHidden
        isLocked
        floorIds
        type
        selectable
        layerName
        isLayerNameEdited
        createdAt
        updatedAt

        coordinates {
            lng
            lat
        }
        isFilled
        fillColor
        fillOpacity
        hasBorder
        borderColor
        borderWidth
        borderOpacity
    }
`);

export const F_MapMarkerWall = gql(`
    fragment F_MapMarkerWall on MapMarkerWall {
        id
        isHidden
        isLocked
        floorIds
        type
        selectable
        layerName
        isLayerNameEdited
        createdAt
        updatedAt

        transformedCoordinates {
            lng
            lat
        }
        originalCoordinates {
            lng
            lat
        }

        structureType
        styleType

        wallIncludeFloor
        wallWidth
        wallColor
        wallOpacity
        wallHeight
        wallBaseHeight

        fillColor
        fillOpacity
        fillHeight
        fillBaseHeight

        floorColor
        floorOpacity
    }
`);

export const F_MapMarkerVariantIcon = gql(`
    fragment F_MapMarkerVariantIcon on MapMarkerVariantIcon {
        id
        isHidden
        isLocked
        floorIds
        type
        selectable
        layerName
        isLayerNameEdited
        createdAt
        updatedAt

        lat
        lng
        color
        textType
        customText
        markerType
        customImageUrl
        sublabel
        highlighted
        imageShowBg
        imageShowContain
        iconName
        eventDate
        eventShowImage

        hasInteractivity
        imageUrl
        text
    }
`);

export const F_MapMarkerImage = gql(`
    fragment F_MapMarkerImage on MapMarkerImage {
        id
        isHidden
        isLocked
        floorIds
        type
        selectable
        layerName
        isLayerNameEdited
        createdAt
        updatedAt

        imageUrl
        originalCoordinates {
            lng
            lat
        }
        transformedCoordinates {
            lng
            lat
        }
        rotation
        opacity
        flipHorizontal
        flipVertical
    }
`);

export const F_MapMarkerText = gql(`
    fragment F_MapMarkerText on MapMarkerText {
        id
        isHidden
        isLocked
        floorIds
        type
        selectable
        layerName
        isLayerNameEdited
        createdAt
        updatedAt

        imageUrl
        originalCoordinates {
            lat
            lng
        }
        transformedCoordinates {
            lat
            lng
        }
        rotation
        opacity
        generatedText
        generatedTextColor
        generatedBackgroundColor
        generatedWidth
        lineLength
    }
`);

export const DetailAttributeValueTextFragment = gql(`
    fragment F_DetailAttributeValueText on DetailAttributeValueText {
        attributeId
        valueString: value
    }
`);

export const DetailAttributeValueLinkFragment = gql(`
    fragment F_DetailAttributeValueLink on DetailAttributeValueLink {
        attributeId
        label
        url
    }
`);

export const DetailAttributeValueBooleanFragment = gql(`
    fragment F_DetailAttributeValueBoolean on DetailAttributeValueBoolean {
        attributeId
        valueBoolean: value
    }
`);

export const DetailAttributeValueNumberFragment = gql(`
    fragment F_DetailAttributeValueNumber on DetailAttributeValueNumber {
        attributeId
        valueNumber: value
    }
`);

export const DetailAttributeValueOptionFragment = gql(`
    fragment F_DetailAttributeValueOption on DetailAttributeValueOption {
        attributeId
        valueOption: value
    }
`);

export const DetailAttributeValueOptionsFragment = gql(`
    fragment F_DetailAttributeValueOptions on DetailAttributeValueOptions {
        attributeId
        valueOptions: value
    }
`);

export const ContentCardTextFragment = gql(`
    fragment F_ContentCardText on ContentCardText {
        id
        title
        text
    }
`);

export const ContentCardExternalLinksFragment = gql(`
    fragment F_ContentCardExternalLinks on ContentCardExternalLinks {
        id
        links {
            label
            url
        }
    }
`);

export const ContentCardImagesFragment = gql(`
    fragment F_ContentCardImages on ContentCardImages {
        id
        imageUrls
    }
`);

export const ContentCardLinkedDetailsFragment = gql(`
    fragment F_ContentCardLinkedDetails on ContentCardLinkedDetails {
        id
        detailIds
    }
`);

export const AppDetailFragment = gql(`
  fragment AppDetail on App_Detail {
      id
      title
      description
      imageUrl
      connectedMarkerIds
      cards {
        ... on ContentCardText {
            ...F_ContentCardText
        }
        ... on ContentCardExternalLinks {
            ...F_ContentCardExternalLinks
        }
        ... on ContentCardImages {
            ...F_ContentCardImages
        }
        ... on ContentCardLinkedDetails {
            ...F_ContentCardLinkedDetails
        }
      }
      attributes {
        attributeId
        ... on DetailAttributeValueText {
            ...F_DetailAttributeValueText
        }
        ... on DetailAttributeValueLink {
            ...F_DetailAttributeValueLink
        }
        ... on DetailAttributeValueBoolean {
            ...F_DetailAttributeValueBoolean
        }
        ... on DetailAttributeValueNumber {
            ...F_DetailAttributeValueNumber
        }
        ... on DetailAttributeValueOption {
            ...F_DetailAttributeValueOption
        }
        ... on DetailAttributeValueOptions {
            ...F_DetailAttributeValueOptions
        }
      }
  }
  `);

export const AppEventFragment = gql(`
  fragment AppEvent on App_Event {
      id
      title
      description
      imageUrl
      dateStart
      dateEnd
      timeStart
      timeEnd
      roomId
      speakerIds
      connectedMarkerIds
      cards {
        ... on ContentCardText {
            ...F_ContentCardText
        }
        ... on ContentCardExternalLinks {
            ...F_ContentCardExternalLinks
        }
        ... on ContentCardImages {
            ...F_ContentCardImages
        }
        ... on ContentCardLinkedDetails {
            ...F_ContentCardLinkedDetails
        }
      }
      attributes {
        attributeId
        ... on DetailAttributeValueText {
            ...F_DetailAttributeValueText
        }
        ... on DetailAttributeValueLink {
            ...F_DetailAttributeValueLink
        }
        ... on DetailAttributeValueBoolean {
            ...F_DetailAttributeValueBoolean
        }
        ... on DetailAttributeValueNumber {
            ...F_DetailAttributeValueNumber
        }
        ... on DetailAttributeValueOption {
            ...F_DetailAttributeValueOption
        }
        ... on DetailAttributeValueOptions {
            ...F_DetailAttributeValueOptions
        }
      }
  }
  `);

export const AppSpeakerFragment = gql(`
  fragment AppSpeaker on App_Speaker { 
      id
      name
      jobPosition
      companyName
      description
      imageUrl
      eventIds
      cards {
        ... on ContentCardText {
            ...F_ContentCardText
        }
        ... on ContentCardExternalLinks {
            ...F_ContentCardExternalLinks
        }
        ... on ContentCardImages {
            ...F_ContentCardImages
        }
        ... on ContentCardLinkedDetails {
            ...F_ContentCardLinkedDetails
        }
      }
      attributes {
        attributeId
        ... on DetailAttributeValueText {
            ...F_DetailAttributeValueText
        }
        ... on DetailAttributeValueLink {
            ...F_DetailAttributeValueLink
        }
        ... on DetailAttributeValueBoolean {
            ...F_DetailAttributeValueBoolean
        }
        ... on DetailAttributeValueNumber {
            ...F_DetailAttributeValueNumber
        }
        ... on DetailAttributeValueOption {
            ...F_DetailAttributeValueOption
        }
        ... on DetailAttributeValueOptions {
            ...F_DetailAttributeValueOptions
        }
      }
  }
  `);

export const AppListFragment = gql(`
    fragment AppList on App_List {
        id
        title
        detailIds
        isFilterable
        isSearchable
        visualisationStyle
        isGrouped
        headerText
        headerButton {
          title
          link {
            destination
            destinationReference
          }
        }
    }
    `);

export const AppEntityAttributeFragment = gql(`
    fragment AppEntityAttribute on App_EntityAttribute {
        id
        title
        type
        options {
            id
            title
        }
    }
    `);

export const AppMapFloorFragment = gql(`
    fragment AppMapFloor on MapFloor {
        id
        name
    }
    `);

export const AppMapFragment = gql(`
    fragment AppMap on App_Map {
        isFilterable
        isSearchable
        initialPosition {
            ... on MapInitialPositionCenter {
            lat
            lng
            zoom
        }
        ... on MapInitialPositionBounds {
            neLat
            neLng
            swLat
            swLng
            padding
        }
      }
      filters {
        attributeId
        allowSelectMultiple
      }
      initialRotation
      initialPitch
      enableGpsLocation
      enableRotation
      enablePan
      locateMarkerZoom
        floors {
            ...AppMapFloor
        }
        markers {
          id
        ... on MapMarkerIndoorStand {
          ...F_MapMarkerIndoorStand
        }
        ... on MapMarkerDirection {
          ...F_MapMarkerDirection
        }
        ... on MapMarkerLabel {
          ...F_MapMarkerLabel
        }
        ... on MapMarkerRoute {
          ...F_MapMarkerRoute
        }
        ... on MapMarkerLine {
          ...F_MapMarkerLine
        }
        ... on MapMarkerPolygon {
          ...F_MapMarkerPolygon
        }
        ... on MapMarkerWall {
          ...F_MapMarkerWall
        }
        ... on MapMarkerVariantIcon {
          ...F_MapMarkerVariantIcon
        }
        ... on MapMarkerImage {
          ...F_MapMarkerImage
        }
        ... on MapMarkerText {
          ...F_MapMarkerText
        }
        }
    }
    `);

export const AppGuideFragment = gql(`
  fragment AppGuide on App_Guide {
    id
    title
    guideType
    logoUrl
    dateStart
    dateEnd
    timeStart
    timeEnd
    entityAttributes {
        ...AppEntityAttribute
    }
    details {
        ...AppDetail
    }
    map {
        ...AppMap
    }
  }
  `);

export const OSLO_GUIDE_QUERY = gql(`
  query Guide($guideIdOrPath: String!) {
    app_guide(guideIdOrPath: $guideIdOrPath) {
      ...AppGuide
    }
  }
`);
